import EmployeePayroll from "../../../../components/company/expense/employee-payroll";

export default function EmployeePayrollPage(){
    return <EmployeePayroll/>
}